import { atom } from "jotai";
export const studentList = atom([
  // {
  //     id:1,
  //     first_name:"suresh",
  //     last_name:"kumar",
  //     phone:"9876543210",
  //     city_id:1,
  //     status:"active",
  //     gender:"male",
  //     address:"kathmandu nepal kathmandu lorem kasdf aslkdjf s afk dlakdfj s",
  //     requirements:"maths physics chemistry",
  // },
  // {
  //     id:2,
  //     first_name:"suresh",
  //     last_name:"kumar",
  //     phone:"9876543210",
  //     city_id:1,
  //     status:"active",
  //     gender:"male",
  //     address:"kathmandu nepal kathmandu lorem kasdf aslkdjf s afk dlakdfj s",
  //     requirements:"maths physics chemistry",
  // }
]);

export const studyLevelState = atom([
  {
    id: 205,
    name: "Primary / Pre-Primary",
  },
  {
    id: 206,
    name: "LKG / UKG",
  },
  {
    id: 207,
    name: "1st Class",
  },
  {
    id: 208,
    name: "2nd Class",
  },
  {
    id: 209,
    name: "3rd Class",
  },
  {
    id: 210,
    name: "4th Class",
  },
  {
    id: 211,
    name: "5th Class",
  },
  {
    id: 212,
    name: "6th Class",
  },
  {
    id: 213,
    name: "7th Class",
  },
  {
    id: 214,
    name: "8th Class",
  },
  {
    id: 215,
    name: "9th Class",
  },
  {
    id: 216,
    name: "10th Class",
  },
  {
    id: 217,
    name: "11th Class",
  },
  {
    id: 218,
    name: "12th Class",
  },
]);
